import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { StyleSheet, View } from 'react-native';
import { AmountPrice, AmountQuantity, CurrencyIdentity } from '../../organisms';
import { createColumnHelper } from '@tanstack/react-table';
import { theme } from '@xbto/design-system';
import { BigOrZero } from 'common';
import { FundTableLayout } from '../fund-table-layout';
import { FUND_TABLE_HEADER_CELL_TEMPLATES } from '../../utils/templates';
import { Amount } from '../../organisms/amount';
import { useCallback } from 'react';
export default function ComponentWeb({ subscriptionsRowData, redemptionsRowData, }) {
    /**
     * DOM
     */
    const columnHelper = createColumnHelper();
    const getColumns = useCallback((type) => [
        columnHelper.accessor('currency', {
            cell: info => {
                const val = info.getValue();
                if (!(val === null || val === void 0 ? void 0 : val.code) || !(val === null || val === void 0 ? void 0 : val.name)) {
                    return;
                }
                return (_jsx(CurrencyIdentity, { apy: BigOrZero(val.apy), code: val.code, name: val.name, 
                    // /!\ Do not pass displayCode for funds /!\`
                    displayCode: null }));
            },
            size: 400,
            header: 'Fund name',
            meta: { justify: 'flex-start', cursor: 'initial', autoWidth: true },
        }),
        columnHelper.accessor('totalInvested', {
            cell: ({ row }) => {
                var _a;
                return (_jsx(AmountQuantity, { signed: true, skipSignedColor: true, color: "primary", currencyCode: ((_a = row.original.secondaryCurrency) === null || _a === void 0 ? void 0 : _a.displayCode) || '', value: row.original.totalInvested }));
            },
            size: 148,
            header: type === 'subscriptions' ? 'Total invested' : 'Total redeemed',
            meta: { justify: 'flex-end', cursor: 'initial' },
        }),
        columnHelper.accessor('noOfShares', {
            cell: info => {
                return _jsx(Amount, { signed: true, color: "primary", value: info.getValue() });
            },
            size: 128,
            header: FUND_TABLE_HEADER_CELL_TEMPLATES.NO_OF_SHARES,
            meta: { justify: 'flex-end', cursor: 'initial' },
        }),
        columnHelper.accessor('totalValue', {
            cell: info => {
                return (_jsx(AmountPrice, { signed: true, skipSignedColor: true, color: "primary", value: info.getValue() }));
            },
            size: 180,
            header: FUND_TABLE_HEADER_CELL_TEMPLATES.VALUE_USD,
            meta: { justify: 'flex-end', cursor: 'initial' },
        }),
    ], [columnHelper]);
    const hasSubscriptions = !!(subscriptionsRowData === null || subscriptionsRowData === void 0 ? void 0 : subscriptionsRowData.length);
    const hasRdemptions = !!(redemptionsRowData === null || redemptionsRowData === void 0 ? void 0 : redemptionsRowData.length);
    return hasSubscriptions || hasRdemptions ? (_jsxs(View, { style: $.container, children: [hasSubscriptions && (_jsx(FundTableLayout, { title: "Your provisional subscriptions", subtitle: "Provisional fund subscriptions are still pending and not reflected in the overall holdings amount.", data: subscriptionsRowData || [], columns: getColumns('subscriptions'), backgroundInverted: true })), hasRdemptions && (_jsx(FundTableLayout, { title: "Your provisional redemptions", subtitle: "Provisional fund redemptions are still pending and not reflected in the overall holdings amount.", data: redemptionsRowData || [], columns: getColumns('redemptions'), backgroundInverted: true }))] })) : null;
}
const $ = StyleSheet.create({
    container: {
        rowGap: theme.spacing[10],
    },
});
